import { useState } from 'react';
import { Link } from 'react-router-dom';
import { BsHeart, BsHeartFill, BsTrash } from 'react-icons/bs';
import { getImageUrl } from '../lib/imageUtils';

const WishlistPage = () => {
  const [wishlistItems, setWishlistItems] = useState([
    {
      id: 1,
      name: 'שרשרת עם אבן ספיר',
      price: 300,
      		image: '/images/products/F1.jpg',
      category: 'necklaces'
    },
    {
      id: 2,
      name: 'עגילי ',
      price: 899,
      		image: '/images/products/T1.jpg',
      category: 'earrings'
    },
    {
      id: 3,
      name: 'טבעת רובי',
      price: 1599,
      		image: '/images/products/F2.jpg',
      category: 'rings'
    }
  ]);

  const removeFromWishlist = (itemId) => {
    setWishlistItems(wishlistItems.filter(item => item.id !== itemId));
  };

  const addToCart = (item) => {
    // כאן תהיה לוגיקה להוספה לעגלה
    console.log('מוצר נוסף לעגלה:', item);
  };

  return (
    <div className="min-h-screen bg-white py-8 px-4">
      <div className="max-w-6xl mx-auto">
        {/* כותרת ראשית */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#9a624b] via-[#ac609c] to-[#9a624b] bg-clip-text text-transparent mb-4">
            רשימת המשאלות שלי
          </h1>
          <p className="text-secondary text-xl">
            שמרו את המוצרים האהובים עליכם לקנייה מאוחרת
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-[#9a624b] to-[#ac609c] mx-auto rounded-full mt-6"></div>
        </div>

        {wishlistItems.length === 0 ? (
          /* רשימה ריקה */
          <div className="bg-white rounded-2xl shadow-2xl p-12 border border-gray-200 text-center">
            <div className="w-24 h-24 bg-gradient-to-r from-[#9B8A61] to-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-6">
              <BsHeart className="w-12 h-12 text-white" />
            </div>
            <h2 className="text-2xl font-bold text-[#9B8A61] mb-4">הרשימה ריקה</h2>
            <p className="text-gray-700 mb-8 max-w-md mx-auto">
              עדיין לא הוספתם מוצרים לרשימת המשאלות שלכם.
              גשו לחנות וגלו את המוצרים היפים שלנו!
            </p>
            <Link
              to="/"
              className="inline-block bg-gradient-to-r from-[#9B8A61] to-[#D4AF37] text-white px-8 py-3 rounded-lg hover:from-[#8A7A51] hover:to-[#C4A027] transition-all duration-300 font-semibold"
            >
              גשו לחנות
            </Link>
          </div>
        ) : (
          /* רשימת מוצרים */
          <div className="space-y-6">
            {/* סטטיסטיקות */}
            <div className="bg-white rounded-2xl shadow-2xl p-6 border border-gray-200">
              <div className="flex flex-col md:flex-row justify-between items-center">
                <div className="text-center md:text-right">
                  <h3 className="text-lg font-semibold text-[#9B8A61]">
                    {wishlistItems.length} מוצרים ברשימה
                  </h3>
                  <p className="text-gray-600 text-sm">
                    סך הכל: ₪{wishlistItems.reduce((sum, item) => sum + item.price, 0).toLocaleString()}
                  </p>
                </div>
                <div className="flex gap-3 mt-4 md:mt-0">
                  <button className="px-6 py-2 bg-gradient-to-r from-[#9B8A61] to-[#D4AF37] text-white rounded-lg hover:from-[#8A7A51] hover:to-[#C4A027] transition-all duration-300 font-medium">
                    הוסף הכל לעגלה
                  </button>
                  <button className="px-6 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-all duration-300 font-medium">
                    שתף רשימה
                  </button>
                </div>
              </div>
            </div>

            {/* רשימת מוצרים */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {wishlistItems.map((item) => (
                <div
                  key={item.id}
                  className="bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden hover:border-[#9B8A61] transition-all duration-300"
                >
                  {/* תמונה */}
                  <div className="relative h-64 overflow-hidden">
                    <img
                      src={getImageUrl(item.image)}
                      alt={item.name}
                      className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                      onError={(e) => {
                        e.target.src = '/images/placeholder.jpg';
                      }}
                    />
                    <div className="absolute top-3 right-3">
                      <button
                        onClick={() => removeFromWishlist(item.id)}
                        className="w-8 h-8 bg-red-600 rounded-full flex items-center justify-center text-white hover:bg-red-700 transition-colors"
                        aria-label="הסר מרשימת המשאלות"
                      >
                        <BsTrash className="w-4 h-4" />
                      </button>
                    </div>
                    <div className="absolute top-3 left-3">
                      <BsHeartFill className="w-6 h-6 text-red-500" />
                    </div>
                  </div>

                  {/* פרטי מוצר */}
                  <div className="p-6">
                    <h3 className="text-lg font-semibold text-gray-700 mb-2">
                      {item.name}
                    </h3>
                    <p className="text-[#D4AF37] font-bold text-xl mb-4">
                      ₪{item.price.toLocaleString()}
                    </p>
                    
                    <div className="flex gap-3">
                      <button
                        onClick={() => addToCart(item)}
                        className="flex-1 bg-gradient-to-r from-[#9B8A61] to-[#D4AF37] text-white py-2 px-4 rounded-lg hover:from-[#8A7A51] hover:to-[#C4A027] transition-all duration-300 font-medium"
                      >
                        הוסף לעגלה
                      </button>
                      <Link
                        to={`/product/${item.id}`}
                        className="flex-1 bg-gray-100 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-200 transition-all duration-300 font-medium text-center"
                      >
                        פרטים
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* המלצות */}
            <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-200">
              <h2 className="text-2xl font-bold text-[#9B8A61] mb-6 text-center">
                מוצרים דומים שיעניינו אתכם
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                {/* כאן יוצגו מוצרים דומים */}
                <div className="text-center text-gray-600">
                  <p>מוצרים דומים יוצגו כאן</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WishlistPage; 